import { Outlet } from "react-router-dom";
// import Spinner from 'react-bootstrap/Spinner';

function App() {

  return (
    <div className="App">
      <div className="cover-when-loading position-fixed top-0 bottom-0 start-0 end-0 justify-content-center align-items-center d-flex d-none">
        <div className="spinner-grow text-warning" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
      <ul className="floatingXO">
        <li>X</li>
        <li>O</li>
        <li>X</li>
        <li>O</li>
        <li>X</li>
        <li>O</li>
        <li>X</li>
        <li>O</li>
        <li>X</li>
        <li>O</li>
      </ul>
      <div className="top-pop-message fixed-bottom mb-4"></div>
      <Outlet />
    </div>
  );
}

export default App;